module.exports = __webpack_public_path__ + "img/331-cc26d8.png";